import api from '../../../api/axios';

const basePath = (slug) =>
  `/cronometraje/live/${encodeURIComponent(slug)}`;

export const liveResultsService = {
  async getResults(slug) {
    if (!slug || typeof slug !== 'string') {
      throw new Error('La competencia no tiene un slug válido.');
    }

    const response = await api.get(basePath(slug), {
      headers: {
        'Cache-Control': 'no-cache'
      }
    });

    return response.data;
  },

  getStreamUrl(slug) {
    if (!slug || typeof slug !== 'string') {
      throw new Error('La competencia no tiene un slug válido.');
    }

    const baseURL = (api.defaults.baseURL || '').replace(/\/+$/, '');

    return `${baseURL}${basePath(slug)}/stream`;
  }
};

export default liveResultsService;